// assets/consentmo-shadow-overrides.js
(function () {
    var STYLE_ID = 'cliphair-consentmo-overrides';
    var MAX_WAIT_MS = 10000; // give up after 10s if banner never appears (e.g. US/Trade)

    function applyOverrides(shadowRoot) {
        if (shadowRoot.getElementById(STYLE_ID)) return; // already applied

        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = `
      @media (max-width: 678px) {
        [aria-label="Cookie consent actions"].cc-compliance {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
        }
        #csm-wrapper .csm-cmp-body{
          padding: 1em !important;
        }
      }
    `;
        shadowRoot.appendChild(style);
    }

    function tryInit() {
        var host = document.querySelector('csm-cookie-consent');
        if (host && host.shadowRoot) {
            applyOverrides(host.shadowRoot);
            return true;
        }
        return false;
    }

    if (!tryInit()) {
        var observer = new MutationObserver(function () {
            if (tryInit()) observer.disconnect();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });

        setTimeout(function () {
            observer.disconnect();
        }, MAX_WAIT_MS);
    }
})();